import './promo-banner.scss';

import ArrowRightIcon from '@/shared/assets/icons/arrow-right.svg?react';
import FireIcon from '@/shared/assets/icons/fire.svg?react';
import RocketIcon from '@/shared/assets/icons/rocket.svg?react';

import type { PromoBannerData } from './types';

type Props = {
  data: PromoBannerData;
  onClick: () => void;
};

export function PromoBanner({ data, onClick }: Props) {
  return (
    <button className="promo-banner" onClick={onClick}>
      <div className="promo-banner__shine" />

      <div className="promo-banner__content">
        <span className="promo-banner__badge">
          <FireIcon width={16} height={16} />
          {data.badge}
        </span>
        <span className="promo-banner__title">{data.title}</span>
        <span className="promo-banner__subtitle">
          <RocketIcon width={16} height={16} className="promo-banner__hint-rocket" />
          {data.subtitle}
          <ArrowRightIcon width={20} height={20} className="promo-banner__hint-arrow" />
        </span>
      </div>

      <div className="promo-banner__visual">
        {data.image && <img src={data.image} alt="" className="promo-banner__lottie" />}
      </div>
    </button>
  );
}
